import { render, staticRenderFns } from "./ProjectEntryWiringsForm.vue?vue&type=template&id=4485c498&scoped=true"
import script from "./ProjectEntryWiringsForm.vue?vue&type=script&lang=js"
export * from "./ProjectEntryWiringsForm.vue?vue&type=script&lang=js"
import style0 from "./ProjectEntryWiringsForm.vue?vue&type=style&index=0&id=4485c498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4485c498",
  null
  
)

export default component.exports